<template>
  <div>
    <div>
      <div>
        <div>
          <div class="row">
            <button class="btn btn-primary btn-xs pull-right" @click="uploadKeywordsFile">Upload keywords</button>
            <input type="file" name="keywords" id="kws" class="pull-right" @change="setKwFile">
          </div>
        </div>
        <div class="ibox-tools">
          <input id="addCat" name="category" ref="catInput" type="text" placeholder="Category" v-model="catName">
          <button @click="addCategory" class="btn btn-primary btn-xs" id="addPyramid">Add Category</button>

          <button class="btn btn-info btn-xs pull-left" @click="setTagTarget('site')">Set Tag Target</button>
        </div>
      </div>
      <div class="row">
        <div class="table-responsive col-lg-12">
          <table class="table table-striped table-bordered table-hover dataTables-example">
            <thead>
            <tr>
              <th class="col-lg-2">
                Category
                <i @click="removeAllVideos" class="fa fa-recycle cat-icon" title="Remove all videos!" id="removeAllVids"></i>
                <i class="fa fa-download cat-icon m-r-xs" title="Download CSV" @click="downloadAllTags"></i>
              </th>
              <th class="col-lg-2" colspan="2">
                Tag
                <i @click="importVideosForAllTags" class="fa fa-play cat-icon m-r" title="Run video import for all tags!" id="importAllTags"></i>
              </th>
              <th title="Video count" class="center col-lg-1">Cnt</th>
              <th title="Target count" class="center col-lg-1">Tgt</th>
              <th class="center col-lg-1">RD</th>
              <th class="center col-lg-1">TF</th>
              <th class="center col-lg-1">KWs</th>
              <th class="center col-lg-1">Vol</th>
              <th class="col-lg-1">
                <i class="fa fa-refresh cat-icon" @click="getCategories(site.url)"></i>
              </th>
            </tr>
            </thead>
            <tbody v-for="cat in categories" :key="cat.term_id">
            <tr>
              <th>
                {{ cat.name }}
                <i @click="removeVideos(cat.term_id)" class="fa fa-recycle cat-icon" title="Remove videos" :id="'removeVids-'+cat.term_id"></i>
                <div class="sk-spinner sk-spinner-wave cat-icon spinner" style="display: none" :id="'spinner-'+cat.term_id">
                  <div class="sk-rect1"></div>
                  <div class="sk-rect2"></div>
                  <div class="sk-rect3"></div>
                  <div class="sk-rect4"></div>
                  <div class="sk-rect5"></div>
                </div>
                <i class="fa fa-download cat-icon m-r-xs" v-tooltip="'Download CSV'" @click="downloadCategoryCsv(cat, cat.tags.data)"></i>
                <i class="btn btn-xs fa fa-eye pull-right" v-tooltip="'show/hide category'" @click="showHideCategory(cat.term_id)"></i>
              </th>
              <th>&nbsp;</th>
              <th class="center">
                {{ cat.category_description.split(/\s|\n/).length }}
                <i class="fa fa-align-justify tag-tool" @click="showCategoryText(cat, cat.category_description)" title="Description"></i>
                <i class="fas fa-cloud-upload-alt tag-tool" title="Generate content" @click="generateItemContent('category', cat.term_id, {cat: cat})"></i>
              </th>
              <th colspan="4">&nbsp;</th>
              <th colspan="3">
                <input type="text" placeholder="Tag name(s)" class="col-lg-6" :id="'tagName-' + cat.term_id " >
                <input type="number" placeholder="Count" min="0" class="col-lg-3 m-l-xs" :id="'tagNum-' + cat.term_id">
                <button class="btn btn-primary btn-xs pull-right" :data-cat="cat.term_id" @click="addTag(cat.term_id)">Add Tag(s)</button>
              </th>
            </tr>
            <tr :key="'head-' + cat.term_id" :class="'cat-term-' + cat.term_id">
                <th class="col-lg-2">
                  Category
                </th>
                <th class="col-lg-2">
                  Tag
                </th>
                <th title="Description length" class="center col-lg-1">Desc</th>
                <th title="Video count" class="center col-lg-1">Cnt</th>
                <th title="Target count" class="center col-lg-1">
                  Tgt
                  <i class="fas fa-bullseye cat-icon" title="Set target count for category" @click="setTagTarget('category', cat.term_id)"></i>
                </th>
                <th class="center col-lg-1">RD</th>
                <th class="center col-lg-1">TF</th>
                <th class="center col-lg-1">KWs</th>
                <th class="center col-lg-1">Vol</th>
                <th class="col-lg-1">
                  <i class="fas fa-compress-arrows-alt tag-tool m-r-sm" v-tooltip="'Fill All Tags (' + showUnfilledTagsNumber(cat.term_id) + ')'"
                  @click="fillAllVideosForTag(cat.term_id)"></i>
                  <i class="fa fa-refresh cat-icon" @click="getCategories(site.url)"></i>
                  {{ showUnfilledTagsNumber(cat.term_id) }}
                </th>
            </tr>
            <template v-for="tag in cat.tags.data">
                <tr :key="tag.tag.term_id" :class="'cat-term-' + cat.term_id">
                <td>
                  <select :name="'tag-cat-' + tag.tag.term_id" v-model="cat.term_id" @change="updateVal($event, 'tagMove', tag.tag.term_id)">
                    <option :value="selCat.term_id" v-for="selCat in categories" :key="selCat.term_id">{{ selCat.name }}</option>
                  </select>
                  <i class="fa fa-video-camera cat-icon m-r-xs" title="Show Videos" @click="loadVidsForTag(tag.tag.term_id, tag.tag.slug)"></i>
                </td>
                <td>
                  <inline-editor
                    :close-on-blur="true"
                    :value="tag.tag.name"
                    @change="updateVal($event, 'tag', tag.tag.term_id)"
                  >
                    <span slot="cancel-label" class="fa fa-remove"></span>
                    <span slot="confirm-label" class="fa fa-save"></span>
                  </inline-editor>
                  <a :href="getTagUrl(tag.tag.slug)" target="_blank"><i class="fa fa-external-link"></i></a>
                  ({{ tag.tag.slug.substring(0,35) }})
                </td>
                <td class="center">
                  {{ tag.tag.description.split(/\n|\s/).length }}
                  <i class="fa fa-align-justify tag-tool" @click="showTagText(tag.tag.term_id, tag.tag.description || '')" :title="tag.tag.description"></i>
                  <i class="fas fa-cloud-upload-alt tag-tool" title="Generate content" @click="generateItemContent('tag', tag.tag.term_id, {tag: tag, cat: cat})"></i>
                </td>
                <td class="center">
                  {{ tag.tag.count }}
                </td>
                <td class="center">
                  <inline-editor
                    :close-on-blur="true"
                    :value="tag.tag.meta.videoTargetCount ? tag.tag.meta.videoTargetCount[0] : ('/')"
                    @change="updateVal($event, 'tagVidCount', tag.tag.term_id)"
                  >
                    <span slot="cancel-label" class="fa fa-remove"></span>
                    <span slot="confirm-label" class="fa fa-save"></span>
                  </inline-editor>
                </td>
                <td class="center">{{ tag.tag.term_id in site.stats ? site.stats[tag.tag.term_id].majestic.RefDomains : '/' }}</td>
                <td class="center">{{ tag.tag.term_id in site.stats ? site.stats[tag.tag.term_id].majestic.TrustFlow : '/' }}</td>
                <td class="center">{{ tag.tag.meta.keywords ? tag.tag.meta.keywords[0] : 0 }}</td>
                <td class="center">{{ tag.tag.meta.kwData[0] ? tag.tag.meta.kwData[0].volume : 0 }}</td>
                <td>
                  <i class="fa fa-remove tag-tool"
                    title="Delete tag and videos"
                    @click="removeTag(tag.tag.term_id)"></i>
                  <i class="fa fa-play tag-tool"
                    @click="importVideosForTag(tag.tag.term_id)"
                    title="Import videos"
                    v-if="tag.tag.count < (tag.tag.meta.videoTargetCount ? tag.tag.meta.videoTargetCount[0] : tag.tag.description)"></i>
                  <i class="fas fa-compress-arrows-alt tag-tool"
                    @click="fillVideosForTag(tag.tag.term_id, cat.term_id, tag.tag.count, (tag.tag.meta.videoTargetCount ? tag.tag.meta.videoTargetCount[0] : tag.tag.description))"
                    title="Fill tag up"
                    v-if="tag.tag.count < (tag.tag.meta.videoTargetCount ? tag.tag.meta.videoTargetCount[0] : tag.tag.description)"></i>
                </td>
              </tr>
                <tr :key="'video-tr-' + tag.tag.term_id" v-if="videoData[tag.tag.slug]">
                  <td colspan="10">
                    <div class="row">
                      <div class="table-responsive col-lg-12">
                        <table class="table table-striped table-bordered table-hover">
                          <thead>
                          <tr>
                            <th class="col-md-1">Category</th>
                            <th class="col-md-1" title="Tag Count">Tag Count</th>
                            <th class="col-md-3">Tags</th>
                            <th class="col-md-3">Title</th>
                            <th class="col-md-1">Desc</th>
                            <th class="col-md-1 center" title="Views in last 7 days">7d V</th>
                            <th class="col-md-1 center" title="Views in last 30 days">30d V</th>
                            <th class="col-md-1 center">KWs</th>
                            <th class="col-md-1">
                              <i class="fa fa-download cat-icon m-r-xs" title="Download CSV" @click="downloadVideosCsv(tag.tag.slug)"></i>
                              <i class="fa fa-remove tag-tool" :title="'Remove ' + selectedVids.length + ' selected video' + (selectedVids.length !== 1 ? 's' : '')" @click="removeSelectedVideos(tag.tag.term_id, tag.tag.slug)" v-if="selectedVids.length"></i>
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="vid in videoData[tag.tag.slug]" :key="'vid-' + tag.tag.slug + '-' + vid.ID">
                            <td>{{ vid.category[0].name }}</td>
                            <td class="center">{{ vid.tags.length }}</td>
                            <td>
                              <v-select
                                name="tags"
                                :id="'vidTags-' + vid.ID"
                                class="col-lg-10"
                                multiple
                                :options="allTags || []"
                                v-model="videoTags[vid.ID]"
                                taggable push-tags />
                              <button class="btn btn-xs btn-primary col-lg-2" @click="updateVideoTags(vid.ID, tag.tag.term_id, tag.tag.slug)">Save</button>
                            </td>
                            <td>
                              <i class="fa fa-star red" v-if="vid.meta.starred && vid.meta.starred[0]" title="Starred video"></i>
                              <inline-editor
                                :close-on-blur="true"
                                :value="vid.post_title"
                                @change="updateVal($event, 'video', vid.ID, {id: tag.tag.term_id, slug: tag.tag.slug})"
                              >
                                <span slot="cancel-label" class="fa fa-remove"></span>
                                <span slot="confirm-label" class="fa fa-save"></span>
                              </inline-editor>
                              <a :href="vid.guid" target="_blank"><i class="fa fa-external-link"></i></a>
                            </td>
                            <td class="center">
                              {{ vid.post_content.length }}
                              <i class="fas fa-cloud-download-alt tag-tool" @click="generateItemContent('video', vid.ID, {video: vid, tag: tag, cat: cat})"></i>
                              <i class="fa fa-align-justify tag-tool" @click="showVideoText(vid, tag.tag)"></i>
                            </td>
                            <td class="center">{{ vid.meta.views_7 ? vid.meta.views_7[0] : 0 }}</td>
                            <td class="center">{{ vid.meta.views_30 ? vid.meta.views_30[0] : 0 }}</td>
                            <td class="center">{{ getKeywordCount(vid.post_name) }}</td>
                            <td>
                              <i class="fa fa-remove tag-tool" @click="deleteVideo(vid.ID, tag.tag.term_id, tag.tag.slug)"></i>
                              <input type="checkbox" name="" @click="selectVid(vid.ID)">
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
            </template>
            </tbody>
            <tbody v-if="orphanTags">
            <tr>
              <th>
                Orphan Tags ({{ orphanTags.length }})
              </th>
              <th colspan="9">&nbsp;</th>
            </tr>
            <tr>
              <th>Category</th>
              <th>Tag</th>
              <th>Videos</th>
              <th colspan="7">&nbsp;</th>
            </tr>
            <tr v-for="tag in orphanTags" :key="tag.term_id">
              <td>
                <select :name="'tag-cat-' + tag.term_id" @change="updateVal($event, 'tagMove', tag.term_id)">
                  <option value="">&gt;&gt;&gt;</option>
                  <option :value="selCat.term_id" v-for="selCat in categories" :key="selCat.term_id">{{ selCat.name }}</option>
                </select>
              </td>
              <td>
                {{ tag.name }}
              </td>
              <td class="center">
                {{ tag.count }}
              </td>
              <td colspan="7">
                <i class="fa fa-remove tag-tool"
                   title="Delete tag and videos"
                   @click="removeTag(tag.tag.term_id)"></i>
              </td>
            </tr>
            </tbody>
            <tbody v-if="orphansLoaded">
            <tr>
              <th>
                Orphan Videos ({{ orphanVideos.length }})
              </th>
              <th colspan="8">&nbsp;</th>
            </tr>
            <tr>
              <td colspan="10">
                <div class="row">
                  <div class="table-responsive col-lg-12">
                    <table class="table table-striped table-bordered table-hover">
                      <thead>
                      <tr>
                        <th class="col-md-2">Category</th>
                        <th class="col-md-3">Tags</th>
                        <th class="col-md-3">Title</th>
                        <th class="col-md-1">KW</th>
                        <th class="col-md-1" title="Views in last 7 days">7d V</th>
                        <th class="col-md-1" title="Views in last 30 days">30d V</th>
                        <th class="col-md-1">
                          <input type="checkbox" name="" id="" @click="selectOrphans">
                          <i class="fa fa-download cat-icon m-r-xs" title="Download CSV" @click="downloadOrphanVideosCsv"></i>
                          <i class="fa fa-remove tag-tool" :title="'Remove ' + selectedVids.length + ' selected video' + (selectedVids.length !== 1 ? 's' : '')" @click="removeSelectedVideos()" v-if="selectedVids.length"></i>
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="vid in orphanVideos" :key="'vid-orphan-' + vid.ID">
                        <td>{{ vid.category[0].name }}</td>
                        <td>
                          <v-select
                            name="tags"
                            :id="'vidTags-' + vid.ID"
                            class="col-lg-10"
                            multiple
                            :options="allTags || []"
                            v-model="videoTags[vid.ID]"
                            taggable push-tags />
                          <button class="btn btn-xs btn-primary col-lg-2" @click="updateVideoTags(vid.ID)">Save</button>
                        </td>
                        <td>{{ vid.post_title }} <a :href="vid.guid" target="_blank"><i class="fa fa-external-link"></i></a></td>
                        <td class="center">
                          {{ getKeywordCount(vid.post_name) }}
                        </td>
                        <td class="center">{{ getVal(vid.meta.views_7) }}</td>
                        <td class="center">{{ getVal(vid.meta.views_30) }}</td>
                        <td>
                          <i class="fa fa-remove tag-tool" @click="deleteVideo(vid.ID)"></i>
                          <input type="checkbox" name="" class="orphanVidCb" @click="selectVid(vid.ID)">
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueInlineTextEditor from 'vue-inline-text-editor'
import Swal from 'sweetalert2'

export default {
  name: 'Videos',
  data () {
    return {
      site: null,
      categories: [],
      catName: '',
      orphanTags: null,
      valUpdate: false,
      catVids: [],
      showVids: false,
      videoData: [],
      allTags: [],
      videoTags: [],
      orphanVideos: [],
      orphansLoaded: false,
      siteStats: {},
      keywords: {},
      keywordsFile: null,
      stats: {},
      selectedVids: [],
      tagDescription: ''
    }
  },
  components: {
    'inline-editor': VueInlineTextEditor
  },
  mounted () {
    this.getSite(this.$route.params.url)
    this.getCategories(this.$route.params.url)
    $('.fAddTag').submit(f => {
      f.preventDefault()
      this.addTag(f)
      return false
    })
  },
  methods: {
    getSite (id) {
      axios.get('/am/site/' + id)
        .then(r => {
          this.site = r.data
          this.lang = r.data.lang
          this.type = r.data.type
          this.getSiteStats()
        })
        .catch(e => {
          console.log(e)
        })
    },
    getLangs () {
      axios.get('/am/langs')
        .then(r => {
          this.langs = r.data
        })
        .catch()
    },
    getCategories (url) {
      axios.get('/am/plugin/site/' + url + '/categories')
        .then(r => {
          this.categories = []
          this.categories = r.data.data
          this.getSite(this.site.url)

          if (r.data['no-parent'].length) {
            this.orphanTags = r.data['no-parent']
          }

          this.categories.forEach(c => {
            c.tags.data.forEach(t => {
              this.allTags.push(t.tag.slug)
            })
          })
          this.loadOrphanVideos()
        })
        .catch(e => {
          console.log(e)
        })
    },
    addCategory () {
      if (this.catName.length < 3) {
        alert('Min 3 chars')
        return false
      } else {
        axios.post('/am/plugin/site/' + this.$route.params.url + '/category', {
          name: this.catName
        })
          .then(r => {
            this.getCategories(this.$route.params.url)
          })
          .catch(e => {
          })
      }
    },
    addTag (catId) {
      let name = $('#tagName-' + catId).val()
      let num = $('#tagNum-' + catId).val()
      if (name.length >= 3) {
        axios.post('/am/plugin/site/' + this.$route.params.url + '/tag', {
          name: name,
          targetCount: num,
          parent: catId
        })
          .then(r => {
            this.getCategories(this.site.url)
            $('#tagName-' + catId).val('')
            $('#tagNum-' + catId).val('')
          })
          .catch(r => {
            this.getCategories(this.site.url)
            $('#tagName-' + catId).val('')
            $('#tagNum-' + catId).val('')
          })
      } else {
        alert('Min 3 chars')
      }
    },
    updateLang () {
      axios.patch('/am/site/' + this.site.url, {
        lang: this.lang
      }).then(r => {
        console.log('lang updated')
      }).catch()
    },
    updateType () {
      axios.patch('/am/site/' + this.site.url, {
        type: this.type
      }).then(r => {
        console.log('type updated')
      }).catch()
    },
    removeVideos (cat) {
      if (confirm('Delete all videos from category?')) {
        $('#spinner-' + cat).css('display', 'block')
        $('#removeVids-' + cat).css('display', 'none')
        axios.patch('/am/plugin/site/' + this.site.url + '/category-clean/' + cat)
          .then(r => {
            this.getCategories(this.site.url)
            $('#spinner-' + cat).css('display', 'none')
            $('#removeVids-' + cat).css('display', 'block')
            this.$toastr.success('Removed ' + r.data.count + ' videos', 'Woohooo!')
          }).catch(e => {
            this.getCategories(this.site.url)
            $('#spinner-' + cat).css('display', 'none')
            $('#removeVids-' + cat).css('display', 'block')
            this.$toastr.error('Whoops, did not work as planned...', 'QQ')
          })
      }
    },
    removeAllVideos () {
      $('#removeAllVids').css('display', 'none')
      if (confirm('Remove all videos from the site?')) {
        axios.delete('/am/plugin/site/' + this.site.url + '/videos').then(r => {
          this.$toastr.success('Deleted ' + r.data.count + ' videos from ' + this.site.url, '8D')
          this.getCategories(this.site.url)
        }).catch(e => {
          this.$toastr.error('Whoops, bad shit happening when deleting all videos (probs timeout, just wait a bit longer)', 'QQ')
          this.getCategories(this.site.url)
        })
      }
    },
    removeTag (tag) {
      if (confirm('Delete tag?')) {
        axios.delete('/am/plugin/site/' + this.site.url + '/tag/' + tag)
          .then(r => {
            this.getCategories(this.site.url)
          }).catch()
      }
    },
    importVideosForTag (tag) {
      if (confirm('Run import?')) {
        // $('#importAllTags').style('display', 'none')
        axios.post('/am/site/' + this.site.url + '/video-import?tag=' + tag)
          .then(r => {
            this.$toastr.success('Queued video import on tag ' + tag + '!', 'Hooray!')
            // $('#importAllTags').style('display', 'block')
          })
          .catch(e => {
            this.$toastr.error('Video import failed miserably.', ':\'(')
            // $('#importAllTags').style('display', 'block')
          })
      }
    },
    importVideosForAllTags () {
      if (confirm('Run import?')) {
        axios.post('/am/site/' + this.site.url + '/video-import')
          .then(r => {
            this.$toastr.success('Queued video import on all tags!', 'Hooray!')
          })
          .catch(e => {
            this.$toastr.error('Video import failed miserably.', ':\'(')
          })
      }
    },
    getTagUrl (tag) {
      let prefix
      if (this.site.options) {
        prefix = this.site.options.tagBase ? this.site.options.tagBase : 'tag'
      } else {
        prefix = 'tag'
      }
      return 'https://' + this.site.url + '/' + prefix + '/' + tag + '/'
    },
    downloadCategoryCsv (category, tags) {
      let csv = '"category","tag","tag url","vids","kws","volume","RD","traffic"\n'
      tags.forEach(tag => {
        csv += '"' + category.slug + '","' + tag.tag.name + '","' + this.getTagUrl(tag.tag.slug) + '","' + tag.tag.count + '","' + this.getKeywordCount(tag.tag.slug) + '","","'
        csv += (tag.tag.term_id in this.site.stats ? this.site.stats[tag.tag.term_id].majestic.RefDomains : '/') + '",""\n'
      })
      const url = window.URL.createObjectURL(new Blob([csv]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', category.slug + '-tags.csv')
      document.body.appendChild(link)
      link.click()
    },
    downloadAllTags () {
      let csv = '"category","tag","tag url","vids","kws","volume","RD","traffic"\n'

      this.categories.forEach(cat => {
        cat.tags.data.forEach(tag => {
          csv += '"' + cat.name + '","' + tag.tag.name + '","' + this.getTagUrl(tag.tag.slug) + '","' + tag.tag.count + '","' + this.getKeywordCount(tag.tag.slug) + '","","'
          csv += (tag.tag.term_id in this.site.stats ? this.site.stats[tag.tag.term_id].majestic.RefDomains : '/') + '",""\n'
        })
      })
      const url = window.URL.createObjectURL(new Blob([csv]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.site.originalUrl + '-tags.csv')
      document.body.appendChild(link)
      link.click()
    },
    loadCatVideos (id) {
      axios.get('/am/plugin/site/' + this.site.url + '/category/' + id + '/videos')
        .then(r => {
          this.catVids[id] = r.data.data
        }).catch()
    },
    updateVal (e, t, i, extras = {}) {
      switch (t) {
        case 'category':
          axios.patch('/am/plugin/site/' + this.site.url + '/category/' + i, {
            data: {
              cat_name: e.target.value
            }
          })
            .then(r => {
              this.getCategories(this.site.url)
            })
          break
        case 'video':
          axios.patch('/am/plugin/site/' + this.site.url + '/video/' + i, {
            data: {
              post_title: e.target.value
            }
          })
            .then(r => {
              this.loadVidsForTag(extras.id, extras.slug)
            })
          break
        case 'tag':
          axios.patch('/am/plugin/site/' + this.site.url + '/tag/' + i, {
            data: {
              name: e.target.value
            }
          })
            .then(r => {
              this.getCategories(this.site.url)
            })
          break
        case 'tagVidCount':
          axios.patch('/am/plugin/site/' + this.site.url + '/tag/' + i, {
            meta: {
              videoTargetCount: e.target.value
            }
          })
            .then(r => {
              this.getCategories(this.site.url)
            })
          break
        case 'tagMove':
          axios.patch('/am/plugin/site/' + this.site.url + '/tag/' + i, {
            data: {
              parent: e.target.value
            }
          })
            .then(r => {
              this.getCategories(this.site.url)
            })
          break
      }
      console.log(e, t, i)
    },
    loadVidsForTag (tagId, slug) {
      // @todo Make this much nicer...
      this.videoData = false
      axios.get('/am/plugin/site/' + this.site.url + '/videos/tag/' + tagId)
        .then(r => {
          this.videoData = []
          this.videoData[slug] = r.data.data
          r.data.data.forEach(t => {
            this.videoTags[t.ID] = []
            t.tags.forEach(vt => {
              this.videoTags[t.ID].push(vt.slug)
            })
          })
        })
        .catch()
    },
    loadOrphanVideos () {
      axios.get('/am/plugin/site/' + this.site.url + '/videos/tag/0')
        .then(r => {
          this.orphanVideos = r.data.data
          if (r.data.data.length) {
            this.orphansLoaded = true
          }
        }).catch()
    },
    updateVideoTags (vidId, tagId, slug) {
      axios.patch('/am/plugin/site/' + this.site.url + '/video/' + vidId, {
        tags: this.videoTags[vidId]
      }).then(r => {
        if (tagId && slug) {
          this.loadVidsForTag(tagId, slug)
        } else {
          this.loadOrphanVideos()
        }
      }).catch()
    },
    deleteVideo (id, tagId, slug, skipConfirmation = false) {
      if (skipConfirmation || confirm('U sure bro?')) {
        axios.delete('/am/plugin/site/' + this.site.url + '/video/' + id)
          .then(r => {
            if (tagId && slug) {
              this.loadVidsForTag(tagId, slug)
            } else {
              this.loadOrphanVideos()
            }
          })
          .catch()
      }
    },
    downloadVideosCsv (slug) {
      let csv = '"category","title","url","wp-url","tag count","tags","kws","weekly views","monthly views"\n'

      this.videoData[slug].forEach(v => {
        csv += '"cat",'
        csv += '"' + v.post_title + '",'
        csv += '"https://' + this.site.url + '//' + v.post_name + '/",' // will probs need to fix
        csv += '"' + v.guid + '",' // will probs need to fix
        csv += '"' + v.tags.length + '",'
        csv += '"",' // Tags comming soon
        csv += '"' + this.getKeywordCount(v.post_name) + '",'
        csv += (this.getStat(v.post_name, 'views', 0).week || 0) + ','
        csv += (this.getStat(v.post_name, 'views', 0).month || 0)
        csv += '\n'
      })
      const url = window.URL.createObjectURL(new Blob([csv]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.site.originalUrl + '-' + slug + '-videos.csv')
      document.body.appendChild(link)
      link.click()
    },
    downloadOrphanVideosCsv () {
      let csv = '"category","title","url","wp-url","tag count","tags","kws","views","views 30 days"\n'

      this.orphanVideos.forEach(v => {
        csv += '"' + (v.category[0].name || 'cat') + '",'
        csv += '"' + v.post_title + '",'
        csv += '"https://' + this.site.url + '//' + v.post_name + '/",' // will probs need to fix
        csv += '"' + v.guid + '",' // will probs need to fix
        csv += '0,'
        csv += '"",'
        csv += '"' + this.getKeywordCount(v.post_name) + '",'
        csv += '"/",'
        csv += '"/"'
        csv += '\n'
      })
      const url = window.URL.createObjectURL(new Blob([csv]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.site.originalUrl + '-orphan-videos.csv')
      document.body.appendChild(link)
      link.click()
    },
    getSiteStats () {
      axios.get('/am/seo/site/' + this.site.url + '/keywords')
        .then(r => {
          this.siteStats.keywords = r.data.data
          r.data.data.forEach(kw => {
            this.keywords[kw.wpUrl] = kw.keywordCount
            this.stats[kw.wpUrl] = kw
            if (kw.wpSlug) {
              this.keywords[kw.wpSlug] = kw.keywordCount
              this.stats[kw.wpSlug] = kw
            }
            if (kw.wpPath) {
              this.keywords[kw.wpPath] = kw.keywordCount
              this.stats[kw.wpPath] = kw
            }
          })
        })
        .catch()
    },
    getKeywordCount (slug) {
      return this.keywords[slug] ? this.keywords[slug] : 0
    },
    getStat (slug, stat, placeholder) {
      if (slug.indexOf('%d8%b9%d8%b1%d8%a7%d9%82%d9%8a%d8%a9') >= 0) {
        console.log(slug + ' || ' + stat)
        console.log(this.stats[slug])
      }
      if (this.stats[slug]) {
        return this.stats[slug][stat] ? this.stats[slug][stat] : placeholder
      } else {
        return placeholder
      }
    },
    setKwFile (e) {
      this.keywordsFile = e.target.files[0]
    },
    uploadKeywordsFile () {
      let formData = new FormData()
      formData.append('file', this.keywordsFile)

      axios.post('/am/seo/site/' + this.site.url + '/site-list',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
        .then(r => {
          this.$toastr.success('Keywords successfully uploaded', 'You da man!')
          this.getSiteStats()
          this.getCategories(this.site.url)
        })
        .catch(e => {
          this.$toastr.error('Try a bit harder. Maybe even use your brain a bit.', 'You messed up!')
        })
    },
    async fillVideosForTag (id) {
      try {
        let r = await axios.post('/am/plugin/site/' + this.site.url + '/tag/' + id + '/fill')
        console.log(r)
        console.log(r.status)
        this.$toastr.success(r.data.msg, 'Woop woop!')
        this.getCategories(this.site.url)
        this.loadOrphanVideos()
      } catch (e) {
        this.$toastr.error(e, 'WTF?!')
      }
    },
    async fillAllVideosForTag (categoryId) {
      let cat = this.categories.filter(c => c.cat_ID === categoryId)
      let tagsIdList = []

      cat[0].tags.data.forEach(t => {
        if (t.tag.meta.videoTargetCount && t.count < parseInt(t.tag.meta.videoTargetCount.join())) {
          tagsIdList.push(t.tag.term_id)
        }
      })

      if (tagsIdList.length > 0) {
        this.$toastr.info('Filling up all tags, this might take a while!')
        let added = 0
        let loopCounter = 0
        tagsIdList.forEach(async (id) => {
          let r = await axios.post('/am/plugin/site/' + this.site.url + '/tag/' + id + '/fill')
          r.status === 200 ? added += 1 : added += 0
          loopCounter += 1
          console.log('LOOP COUNTER: ' + loopCounter)
          if (loopCounter === tagsIdList.length) {
            this.$toastr.success('Woop woop! ' + added + ' tags filled up')
            this.getCategories(this.site.url)
            this.loadOrphanVideos()
            this.showUnfilledTagsNumber(id)
          }
        })
      }
    },
    showUnfilledTagsNumber (categoryId) {
      let cat = this.categories.filter(c => c.cat_ID === categoryId)
      let tagsIdList = []

      cat[0].tags.data.forEach(t => {
        if (t.tag.meta.videoTargetCount && t.count < parseInt(t.tag.meta.videoTargetCount.join())) {
          tagsIdList.push(t.tag.term_id)
        }
      })

      return tagsIdList.length
    },
    selectVid (id) {
      if (this.selectedVids.indexOf(id) !== -1) {
        this.selectedVids = this.selectedVids.filter(e => e !== id)
      } else {
        this.selectedVids.push(id)
      }
    },
    removeSelectedVideos (tag, slug) {
      if (confirm('Delete ' + this.selectedVids.length + ' videos?')) {
        this.selectedVids.forEach(v => {
          this.deleteVideo(v, null, null, true)
        })
      }
    },
    selectOrphans (e) {
      $('.orphanVidCb').each((t, a) => {
        $(a).trigger('click')
      })
    },
    getVal (val) {
      return val && val[0] ? val[0] : '/'
    },
    async showTagText (id, description) {
      const { value: desc } = await Swal.fire({
        title: 'Description',
        input: 'textarea',
        showCancelButton: true,
        confirmButtonText: 'Save',
        cancelButtonText: 'Just leave it as is...',
        inputValue: description
      })

      if (desc) {
        axios.patch('/am/plugin/site/' + this.site.url + '/tag/' + id, {
          data: {
            description: desc
          }
        })
          .then(r => {
            this.$toastr.success('Description updated.', 'Hi 5')
            this.getCategories(this.site.url)
          })
          .catch(e => {})
      }
    },
    async showVideoText (vid, tag) {
      const { value: desc } = await Swal.fire({
        title: 'Post Content',
        input: 'textarea',
        showCancelButton: true,
        confirmButtonText: 'Save',
        cancelButtonText: 'Never mind...',
        inputValue: vid.post_content
      })

      if (desc) {
        axios.patch('/am/plugin/site/' + this.site.url + '/video/' + vid.ID, {
          data: {
            post_content: desc
          }
        })
          .then(r => {
            this.$toastr.success('Description updated.', 'Hi 5')
            this.loadVidsForTag(tag.term_id, tag.slug)
          })
          .catch(e => {})
      }
    },
    async showCategoryText (cat) {
      const { value: desc } = await Swal.fire({
        title: 'Category Description',
        input: 'textarea',
        showCancelButton: true,
        confirmButtonText: 'Save',
        cancelButtonText: 'Never mind...',
        inputValue: cat.category_description
      })

      if (desc) {
        axios.patch('/am/plugin/site/' + this.site.url + '/category/' + cat.term_id, {
          data: {
            category_description: desc
          }
        })
          .then(r => {
            this.$toastr.success('Description updated.', 'Hi 5')
            this.getCategories(this.site.url)
          })
          .catch(e => {})
      }
    },
    generateItemContent (type, id, item) {
      if (!confirm('You sure about that sir?')) return
      let kw, kws, vidId
      switch (type) {
        case 'tag':
          kw = item.tag.tag.name
          kws = item.cat.cat_name
          break
        case 'video':
          kw = item.video.post_title
          kws = [item.cat.cat_name, item.tag.tag.name]
          vidId = item.video.meta.video_id[0]
          break
        case 'category':
          kw = item.cat.cat_name
          kws = item.cat.tags.data.map(t => t.tag.name)
          break
      }
      axios.post('/am/plugin/site/' + this.site.url + '/ai-content', {
        keyword: kw,
        subKeywords: kws,
        language: this.site.lang,
        length: 'short',
        target: {
          type: type,
          id: id,
          videoId: vidId
        }
      })
        .then(r => {
          this.$toastr.success('Now sit on your hands a bit and wait a minute or two', 'Request processed')
        })
        .catch()
    },
    async setTagTarget (type, id) {
      const { value: count } = await Swal.fire({
        title: type === 'category' ? 'Category target' : 'Site target',
        input: 'number',
        showCancelButton: true,
        confirmButtonText: 'Save',
        cancelButtonText: 'Never mind...'
      })
      if (!count) {
        return
      }
      switch (type) {
        case 'site':
          axios.patch('/am/plugin/site/' + this.site.url + '/all-tags', {
            meta: {
              videoTargetCount: count
            }
          })
            .then(r => {
              this.getCategories(this.site.url)
              this.$toastr.success('Successfully updated all the bloody tags', 'Here you go you lazy bastard...')
            })
            .catch(e => {
              this.$toastr.error(e)
            })
          break
        case 'category':
          this.categories.forEach(c => {
            if (c.cat_ID === id) {
              let changed = 0
              c.tags.data.forEach(t => {
                axios.patch('/am/plugin/site/' + this.site.url + '/tag/' + t.tag.term_id, {
                  meta: {
                    videoTargetCount: count
                  }
                })
                  .then(r => {
                    changed++
                  })
                  .catch(e => {
                    console.log(e)
                  })
              })
              this.$toastr.success('Changed target on ' + changed + 'tags', 'Groovy baby')
              this.getCategories(this.site.url)
            }
          })
          break
      }
    },
    showHideCategory (catTermId) {
      console.log(catTermId)
      // :class="'cat-term-' + cat.term_id"
      document.querySelectorAll('.cat-term-' + catTermId).forEach(c => {
        c.style.display !== 'none' ? c.style.display = 'none' : c.style.display = ''
      })
    }
  }
}
</script>

<style scoped>
  .cat-icon {
    cursor: pointer;
    color: grey;
    float: right;
  }

  .tag-tool {
    cursor: pointer;
  }

  .cat-icon:hover, .tag-tool:hover {
    color: green;
  }
  .tag-icon {
    padding: 0 0 0 5px;
    cursor: pointer;
    float: right;
  }
  .tag-icon:hover {
    color: red;
  }
  .spinner {
    height: 15px;
  }
  .center {
    text-align: center;
  }
  .red {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/Manager/Site/Videos.vue